module.exports = __webpack_public_path__ + "static/media/dentalHy.cac91521.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dentalHy.jpg
// module id = 496
// module chunks = 0